import { Injectable } from '@angular/core';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { Observable, tap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TokenModel } from '../models/TokenModel';
import { UserModel } from '../models/UserModel';
import { SignUpAllFieldsBuyer } from '../classes/SignUpAllFieldsBuyer';
import { SignUpAllFieldsSeller } from '../classes/SignUpAllFieldsSeller';
import { EmailConfirmationFields } from '../classes/EmailConfirmationFields';
import { PasswordRecoveryFields } from '../classes/PasswordRecoveryFields';

@Injectable({
	providedIn: 'root'
})
export class AuthRequestsService {

	private readonly API_AUTH_ROUTE: string;

	constructor(private http: HttpClient) {
		this.API_AUTH_ROUTE = environment.API_URL + "/mia-auth";
	}

	login(email: string, password: string): Observable<ServerResponse<UserModel>> {
		let route = this.API_AUTH_ROUTE + "/login";

		return this.http.post<ServerResponse<UserModel>>(route, {
			email: email,
			password: password
		});
	}

	me(token: TokenModel): Observable<ServerResponse<UserModel>> {
		let route = this.API_AUTH_ROUTE + "/me";

		let headers = new HttpHeaders({
			Authorization: "Bearer " + token.access_token,
		});

		return this.http.get<ServerResponse<UserModel>>(route, { headers: headers });
	}

	refreshToken(token: TokenModel): Observable<ServerResponse<UserModel>> {
		let route = this.API_AUTH_ROUTE + "/refresh-token"
		let headers = new HttpHeaders({
			Authorization: "Bearer " + token.access_token,
		});

		return this.http.post<ServerResponse<UserModel>>(route, { refresh_token: localStorage.getItem('refreshToken') }, { headers: headers });
	}

	isThisEmailTaken(email: string): Observable<ServerResponse<boolean>> {
		let route = this.API_AUTH_ROUTE + "/account-exists";
		return this.http.post<ServerResponse<boolean>>(route, { email: email });
	}

	isThisCuitTaken(cuit_cuil: string): Observable<ServerResponse<boolean>> {
		let route = this.API_AUTH_ROUTE + "/cuit-exists";
		return this.http.post<ServerResponse<boolean>>(route, { cuit_cuil: cuit_cuil });
	}
	signUp(signUpFields: SignUpAllFieldsBuyer | SignUpAllFieldsSeller): Observable<ServerResponse<true>> {
		let route = this.API_AUTH_ROUTE + "/register";
		return this.http.post<ServerResponse<true>>(route, signUpFields);
	}
	emailConfirmation(emailConfirmationFields: EmailConfirmationFields): Observable<ServerResponse<boolean>> {
		let route = this.API_AUTH_ROUTE + "/activate-account";
		return this.http.post<ServerResponse<boolean>>(route, emailConfirmationFields);
	}

	loginWithGoogle(googleToken: string): Observable<ServerResponse<UserModel>> {
		let route = this.API_AUTH_ROUTE + "/login-with-google";
		return this.http.post<ServerResponse<UserModel>>(route, { token: googleToken });
	}

	forgotPassword(email: string): Observable<ServerResponse<boolean>> {
		let route = this.API_AUTH_ROUTE + "/recovery";
		return this.http.post<ServerResponse<boolean>>(route, { email: email });
	}

	passwordRecovery(fields: PasswordRecoveryFields): Observable<ServerResponse<boolean>> {
		let route = this.API_AUTH_ROUTE + "/change-password-recovery";
		return this.http.post<ServerResponse<boolean>>(route, fields);
	}
}
